import { KAPLAYCtx } from "kaplay";
import { GAME, NPC } from "./constants";
import type { NPC as NPCType, Player, UIElements } from "./types";

export function createUIElements(k: KAPLAYCtx): UIElements {
  const raceTrackWidth = k.width() - 40;
  const raceTrackHeight = 6;
  const raceTrackX = 20;
  const raceTrackY = k.height() - 20;

  return {
    raceTrackBackground: k.add([
      k.rect(raceTrackWidth, raceTrackHeight),
      k.pos(raceTrackX, raceTrackY),
      k.color(100, 100, 100),
      k.opacity(0.7),
      k.fixed(),
      k.z(1000),
    ]),

    playerRaceIcon: k.add([
      k.sprite("player"),
      k.pos(raceTrackX, raceTrackY + raceTrackHeight / 2),
      k.anchor("center"),
      k.fixed(),
      k.z(1001),
      k.opacity(0),
      "playerIcon",
    ]),

    npcRaceIcon: k.add([
      k.sprite("mark"),
      k.pos(raceTrackX, raceTrackY + raceTrackHeight / 2),
      k.anchor("center"),
      k.fixed(),
      k.z(1001),
      k.opacity(0),
      "npcIcon",
    ]),

    finishLine: k.add([
      k.rect(2, raceTrackHeight + 8),
      k.pos(raceTrackX + raceTrackWidth - 2, raceTrackY - 4),
      k.color(255, 255, 255),
      k.opacity(0.8),
      k.fixed(),
      k.z(1001),
    ]),
  };
}

export function resizeUIElements(uiElements: UIElements, k: KAPLAYCtx): void {
  const raceTrackWidth = k.width() - 40;
  const raceTrackHeight = 6;
  const raceTrackX = 20;
  const raceTrackY = k.height() - 20;

  uiElements.raceTrackBackground.width = raceTrackWidth;
  uiElements.raceTrackBackground.height = raceTrackHeight;
  uiElements.raceTrackBackground.pos.x = raceTrackX;
  uiElements.raceTrackBackground.pos.y = raceTrackY;

  uiElements.finishLine.pos.x = raceTrackX + raceTrackWidth - 2;
  uiElements.finishLine.pos.y = raceTrackY - 4;
  uiElements.finishLine.height = raceTrackHeight + 8;
}

export function updateUIElements(
  uiElements: UIElements,
  k: KAPLAYCtx,
  player: Player,
  npc: NPCType,
  gameStarted: boolean,
): void {
  const playerDistanceTraveled = player.x - GAME.START_X;
  const npcDistanceTraveled = npc.x - (GAME.START_X - NPC.START_OFFSET);

  const raceTrackWidth = k.width() - 40;
  const raceTrackX = 20;
  const raceTrackY = k.height() - 20;

  const playerProgress = Math.min(
    playerDistanceTraveled / GAME.TARGET_DISTANCE,
    1.0,
  );
  const npcProgress = Math.min(npcDistanceTraveled / GAME.TARGET_DISTANCE, 1.0);

  const playerIconX = raceTrackX + (raceTrackWidth - 20) * playerProgress;
  uiElements.playerRaceIcon.pos.x = playerIconX;
  uiElements.playerRaceIcon.pos.y = raceTrackY + 6 / 2;

  const iconSize = 32;
  uiElements.playerRaceIcon.width = iconSize;
  uiElements.playerRaceIcon.height = iconSize;

  const npcIconX = raceTrackX + (raceTrackWidth - 20) * npcProgress;
  uiElements.npcRaceIcon.pos.x = npcIconX;
  uiElements.npcRaceIcon.pos.y = raceTrackY + 6 / 2;
  uiElements.npcRaceIcon.width = iconSize;
  uiElements.npcRaceIcon.height = iconSize;

  const targetOpacity = gameStarted ? 0.8 : 0;
  uiElements.raceTrackBackground.opacity = targetOpacity;
  uiElements.playerRaceIcon.opacity = gameStarted ? 1 : 0;
  uiElements.npcRaceIcon.opacity = gameStarted ? 1 : 0;
  uiElements.finishLine.opacity = targetOpacity;
}
